import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import {
  myProfile,
  myProfileFailed,
  myProfileSuccess,
  updateUserProfile,
  updateUserProfileFailed,
  updateUserProfileSuccess,
} from "./slice";
import { selectMyProfileState } from "./selector";

//--------------------MyProfileSagaSaga-------------------------

function* myProfileSaga(action: ReturnType<typeof myProfile>): any {
  try {
    const response = yield call(request.get, `${endpoints.myProfile}`);
    yield put(myProfileSuccess(response.data));
  } catch (error: any) {
    yield put(myProfileFailed(error));
  }
}
//--------------------UpdateUserProfileSagas-------------------------

function* updateSalesPersonSagas(
  action: ReturnType<typeof updateUserProfile>
): any {
  try {
    const { id, firstName, lastName, phone, profileImage } = action.payload;

    const myProfile = yield select(selectMyProfileState);

    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("phone", phone);

    if (profileImage) {
      formData.append("profileImage", profileImage);
    }

    const { data } = yield call(
      request.put,
      `${endpoints.updateUserProfile}/${id}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    yield put(updateUserProfileSuccess(data));
    const updateProfile = {
      ...myProfile.data,
      firstName: data?.firstName,
      lastName: data?.lastName,
      phone: data?.phone,
      profileImage: data?.profileImage,
    };
    yield put(myProfileSuccess(updateProfile));
  } catch (error: any) {
    yield put(updateUserProfileFailed(error));
  }
}

function* myProfileSagas() {
  yield all([takeLatest(myProfile, myProfileSaga)]);
  yield all([takeLatest(updateUserProfile, updateSalesPersonSagas)]);
}

export { myProfileSagas };
